type ClerkErrorShape = {
  errors?: Array<{
    longMessage?: string;
    message?: string;
  }>;
  message?: string;
};

export function getClerkErrorMessage(error: unknown): string {
  if (typeof error === 'string' && error) {
    return error;
  }

  if (error && typeof error === 'object') {
    const clerkError = error as ClerkErrorShape;
    const clerkMessage = clerkError.errors?.[0]?.longMessage || clerkError.errors?.[0]?.message;
    if (clerkMessage) {
      return clerkMessage;
    }

    if (clerkError.message) {
      return clerkError.message;
    }
  }

  return 'Something went wrong. Try again.';
}

export function getClerkErrorCode(error: unknown): string | undefined {
  if (error && typeof error === 'object') {
    const clerkError = error as ClerkErrorShape & { errors?: Array<{ code?: string }> };
    return clerkError.errors?.[0]?.code ?? undefined;
  }
  return undefined;
}

export const DEFAULT_AFTER_AUTH_URL = '/dashboard';
export const AUTH_DISABLED_MESSAGE = 'Set VITE_CLERK_PUBLISHABLE_KEY to enable sign in.';
